import * as React from 'react';
import API from "../../../common/AxoisClient";
import AsyncSelect from "react-select/async";
import {getQueryStringParams,SearchSelect, SearchInput} from "../../../common";
import _ from 'lodash';
interface IPlayerOption {
  id: number;
  text: string;
}
interface IState {
  form: {
    like: {
      message: string,
    },
    equal: {
      action_by: number | "";
      action_by_text: string;
    };
    custom: {
      club_id: number;
      team_id: number | "";
    };
  };
  playerOptions: IPlayerOption[];
}

export default class SMSFilter extends React.Component<any, IState> {
  state: IState;

  UNSAFE_componentWillMount() {
    let old_data: any = getQueryStringParams("form");
    old_data = JSON.parse(old_data);
    this.setState({form:  {
        like: {
          message: old_data ? old_data.like.message : '',
        },
        equal: {
          action_by: old_data ? old_data.equal.action_by : "",
          action_by_text: old_data ? old_data.equal.action_by_text : "",
        },
        custom: {
          club_id: old_data ? old_data.custom.club_id : "",
          team_id: old_data ? old_data.custom.team_id : "",
        },
      },
    });
  }

  async componentDidMount() {
    this.updateForm(this.state.form, "", true);
  }

  // helper to fetch users
  fetchUsers = async (inputValue: string = "", club_id: number | "" = "", team_id: number | "" = "") => {
    const res = await API.post("activitylogs/user-search-list", {
      params: {
        q: inputValue,
        club_id,
        team_id,
      },
    });
    return res.data.results.map((item: any) => ({
      id: item.id,
      text: item.name,
    }));
  };

  updateForm = async (newForm: any, key?: string, skipApi: boolean = false) => {
    let playerOptions = this.state.playerOptions || [];
    if (!playerOptions.length || key === "club_id" || key === "team_id") {
      playerOptions = await this.fetchUsers( "", newForm.custom.club_id, newForm.custom.team_id );
    }

    const selectedUser = playerOptions.find(
      (u: any) => u.id == newForm.equal.action_by
    );

    if (selectedUser && !newForm.equal.action_by_text) {
      newForm.equal.action_by_text = selectedUser.text;
    }

    this.setState({ form: newForm, playerOptions });

    if (!skipApi) {
      const payload = { ...newForm, equal: { action_by: newForm.equal.action_by }};
      this.props.getResults(payload);
    }
  };

  handleInputForm = (e: any) => {
    const [, group, key] = e.target.name.split(".");
    const newForm = { ...this.state.form };
    newForm[group][key] = e.target.value;
    if (key === "club_id") {
      newForm.custom.team_id = "";
      newForm.equal.action_by = "";
    } else if (key === "team_id") {
      newForm.equal.action_by = "";
    }
    this.updateForm(newForm, key);
  };

  getTeams = (clubs, club_id) => {
    const club = clubs.filter(item => item.id == club_id);
    return _.get(club, "[0].teams", []);
  }


  render(){
    const Insta = this;
    const { clubs } = this.props;
    const teams = [{"label": "Select Team", "value": ""}, ...this.getTeams(clubs, this.state.form.custom.club_id)];
    return (
      <div className="row">
      <SearchInput name={'form.like.message'} value={this.state.form.like.message} onChange={this.handleInputForm} placeholder={'Enter message'} />
      <SearchSelect name={'form.custom.club_id'} value={this.state.form.custom.club_id}  onChange={this.handleInputForm} options={clubs}/>
      <SearchSelect name={'form.custom.team_id'} value={this.state.form.custom.team_id}  onChange={this.handleInputForm} options={teams}/>
        <div className="col-md-3 kt-margin-b-20-tablet-and-mobile">
          <div className="kt-form__group kt-form__group--inline">
            <div className="kt-form__label">
              <label />
            </div>
            <div className="kt-form__control">
              <div className="kt-form__control">
                <AsyncSelect cacheOptions isClearable={true}
                  defaultOptions={this.state.playerOptions || []}   
                  loadOptions={(inputValue) => this.fetchUsers(inputValue, this.state.form.custom.club_id, this.state.form.custom.team_id)}
                  getOptionLabel={(option: any) => option.text} getOptionValue={(option: any) => option.id}
                  onChange={(selectedOption: any) => {
                    const newForm = { ...this.state.form };
                    newForm.equal.action_by = selectedOption?.id || "";
                    newForm.equal.action_by_text = selectedOption?.text || "";
                    this.updateForm(newForm);
                  }}
                  value={ this.state.form.equal.action_by ? { id: this.state.form.equal.action_by, text: this.state.form.equal.action_by_text } : null }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
